import React from "react";

type SpaceMessageLoadingStateProps = {
    isLoading?: boolean;
    message?: string;
    className?: string;
};

const SpaceMessageLoadingState = ({
    isLoading = true,
    message = "Loading messages...",
    className = "",
}: SpaceMessageLoadingStateProps) => {
    if (!isLoading) return null;

    return (
        <div className={`flex items-center justify-center py-8 ${className}`}>
            <div className="flex items-center space-x-3">
                {/* SVG Icon with rotation animation */}
                <div className="w-4 h-4 animate-spin">
                    <img
                        src="https://storage.googleapis.com/heysynth_files/synth_webapp/space-message-loader.svg"
                        alt="Loading"
                        className="w-full h-full"
                        onError={(e) => {
                            // Fallback to a CSS spinner if SVG fails to load
                            e.currentTarget.style.display = "none";
                            if (e.currentTarget.parentElement) {
                                e.currentTarget.parentElement.innerHTML =
                                    '<div class="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>';
                            }
                        }}
                    />
                </div>

                {/* Loading text */}
                <p className="text-sm text-gray-500 font-medium">{message}</p>
            </div>
        </div>
    );
};

export default SpaceMessageLoadingState;
